<template>
  <div>
    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <template v-if="icard_common_data != null">
  <div v-for="(inst_data, ind) in icard_data" :key="ind">
    
    <div class="cardbody" style="font-weight: 1000">
      <div style="width: 18.3rem">
        <div>
          <div class="row" style="position: relative;">
            <img
              :src="icard_common_data.logo"
              height="70"
              width="80"
              alt="logo"
            />
            <span
              class="bold-print"
              v-html="icard_common_data.heading"
            ></span>
          </div>
          
          <center>
            <h3 class="bold-print pt-8">{{ inst_data.emp_code }}</h3>
          </center>
          
          <div class="empimg" style="margin-top: -3px !important">
            <center>
              <img
                :src="inst_data.profile_photo_path"
                style="width: 56%; height: 180px; border: black solid 2px"
              />
            </center>
          </div>
          
          <v-img
            style="height: 167px; margin-top: -26px; width: 320px;"
            :src="icard_common_data.watermark"
          >
                <center>
                  <div
                    class="text-center white--text pt-5 mt-10"
                    style="font-size: x-large; font-weight: bold"
                  >
                    {{ inst_data.first_name }} &nbsp;&nbsp;
                    {{ inst_data.last_name }}
                  </div>
                  <div
                    class="text-center white--text"
                    style="font-size: large; font-weight: bold"
                  >
                    {{ inst_data.designation }}
                  </div>
                  <div
                    style="
                      position: absolute;
                      bottom: 10px;
                      margin-right: 40%;
                      margin-left: -17px;
                    "
                    class="white--text mb-1"
                  >
                    <img
                      :src="icard_common_data.sign"
                      style="width: 120px; height: 30px; padding-left: 25px"
                      alt="logo"
                    />
                  </div>
                  <div
                    style="position: absolute; bottom: 0px"
                    class="white--text ml-1"
                  >
                    <strong> Authorised Signatory</strong>
                  </div>
                  <div
                    style="
                      position: absolute;
                      right: -3px;
                      bottom: -12px;
                      width: 65px;
                      height: 65px;
                    "
                  >
                    <img
                      src="https://vgespl-sbpps.s3.ap-south-1.amazonaws.com/Role_link_icons/sbpps/1/rids_year_cmyk(14-08-2025)-np-02(1)(1)99rpcrtq8n.png"
                      style="
                        width: 45px;
                        height: 45px;
                        object-fit: contain;
                      "
                    />
                  </div>
                </center>
              </v-img>
            </div>
          </div>
        </div>
        <br />

        <div
          class="cardbody1 pagebreak"
          style="margin-top: -12px; font-weight: 1000"
        >
          <div style="width: 18.3rem" :class="{ bottom: isEnabled }">
            <div>
              <div :class="{ 'mrgn': isEnabled }" style="margin-top: -2px;">
                <v-img :src="icard_common_data.watermark_back"></v-img>
              </div>
            </div>
            <div class="ml-2 bold-print" style="font-size: small">
              <strong>Date of Birth :- </strong> {{ inst_data.emp_dob }}<br />
              <strong>Blood Group :- </strong>{{ inst_data.emp_blood_group
              }}<br />
              <strong>Contact No. :- </strong> {{ inst_data.emp_contact }}<br />
              <strong>Email :- </strong>{{ inst_data.emp_email_official }}<br />
            </div>
            <div class="ml-2 bold-print" style="font-size: small; height: 55px">
              <strong>Address :- </strong>{{ inst_data.emp_address }}<br />
            </div>
            <span class="ml-3"><strong>Instruction</strong></span>
            <hr style="width: 95%; margin: auto" />
            <v-row
              style="
                font-size: xx-small;
                text-indent: -1.5em;
                padding-left: 1.5em;
              "
              dense
              class="ml-3"
              v-for="(i, index) in icard_common_data.instruction"
              :key="index"
            >
              <b> {{ index + 1 }} . {{ i.topic }}</b>
            </v-row>
            <center>
              <barcode
                style="margin-top: -4px"
                height="20"
                width="1"
                v-model="inst_data.emp_code"
                v-bind:value="inst_data.emp_code"
              >
              </barcode>
            </center>
            <div class="mt-1 bold-print" style="background: #0095cb; margin-top: -5px">
              <v-row class="ml-2" dense style="font-size: x-small">{{
                icard_common_data.school_name
              }}</v-row>
              <hr />
              <v-row dense class="ml-2" style="font-size: x-small"
                >{{ icard_common_data.school_address }}
              </v-row>
              <v-row dense class="ml-2" style="font-size: x-small"
                >Contact No. :- {{ icard_common_data.school_contact }}</v-row
              >
              <v-row dense class="ml-2" style="font-size: x-small"
                >Email :- {{ icard_common_data.email }}
                <v-spacer></v-spacer> Website :- {{ icard_common_data.website }}
              </v-row>
            </div>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>
  
  <script>
import axios from "axios";
import VueBarcode from "vue-barcode";

import "@/assets/css/color.css"; // css needs to be imported for each dashboard

export default {
  components: {
    barcode: VueBarcode,
  },
  data: () => ({
    snackbar_msg: "",
    color: "",
    snackbar: false,
    comp_load: false,
    inst_list: null,
    radios: null,
    inst_data: null,
    icard_data: [],
    barcodeValue: "",
    authority: "Principal",
    authority_sign: null,
    icard_common_data: null,
    overlay: false,
  }),
  mounted() {
    this.isEnabled = localStorage.getItem("isEnabled") === "true";
    this.icardGenerate();
  },
  methods: {
    icardGenerate() {
      const data = {
        inst_data: this.inst_data,
      };
      this.overlay = true;
      axios
        .post("/Icard/icardBulkGenerate", data)
        .then((res) => {
          if (res.data.flag == "YES") {
            this.icard_data = res.data.icard_data;
            this.icard_common_data = res.data.icard_common_data;
          } else {
            alert(res.data.snackbar);
          }
          this.overlay = false;
        })

        .catch((error) => {
          console.log("Error", error);
          alert("Somthing went wrong!!!");
          this.overlay = false;
        })
        .finally(() => {
          this.comp_load = false;
        });
    },
  },
};
</script>
  
  <style scoped>
.bottom {
  -ms-transform: rotate(180deg);
  -webkit-transform: rotate(180deg);
  transform: rotate(180deg);
}
.cardbody {
  width: 300px;
  display: inline-block;
  border-radius: 5px;
  padding: 5px;
  height: 480px;
  padding-top: 15px;
}

/* .cardbody1 {
  width: 300px;
  display: inline-block;
  border-radius: 5px;
  padding: 5px;
  height: 480px;
  padding-top: 15px;
} */
.cardbody1 {
  width: 300px;
  display: inline-block;
  border-radius: 5px;
  padding: 5px;
  height: 490px;
}
* {
  -webkit-print-color-adjust: exact;
  print-color-adjust: exact;
}
.empimg {
  margin-bottom: 20px;
  margin-top: 8px;
}
.mrgn {
  margin-right: 3px;
  margin-left: -2px;
  margin-bottom: 3px;
}
@media print {
  .bold-print{
    font-weight: 800 !important;
  }
  .pagebreak {
    page-break-before: always !important;
  }

  @page {
    margin: -0.2645833mm;
    size: 53mm 86.614mm;
  }

  .logo {
    height: 80%;
  }
}
</style>
  
